// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/common/client.proto
/* eslint-disable */
import * as _m0 from "protobufjs/minimal.js";
import { Country } from "./countries.js";
import { Language } from "./languages.js";
import { DateTime } from "./time.js";
// For Node.js to access named exports from CommonJS
const __m0 = 'default' in _m0 ? _m0.default : _m0;
export const protobufPackage = "squareup.common.client";
/**
 * The category of a prerelease. Usually identified by a prerelease
 * demarcation: e.g., the b in 4.2.1b6 means BETA. Modeled after
 * rubygems. Values should have a meaningful sort order.
 */
export var Version_PrereleaseType;
(function (Version_PrereleaseType) {
    Version_PrereleaseType[Version_PrereleaseType["ALPHA"] = 10] = "ALPHA";
    Version_PrereleaseType[Version_PrereleaseType["BETA"] = 20] = "BETA";
    Version_PrereleaseType[Version_PrereleaseType["PRERELEASE"] = 30] = "PRERELEASE";
    Version_PrereleaseType[Version_PrereleaseType["RELEASE_CANDIDATE"] = 40] = "RELEASE_CANDIDATE";
})(Version_PrereleaseType || (Version_PrereleaseType = {}));
export var Product_Application;
(function (Product_Application) {
    /** REGISTER - Square's main app. was known at one point as Square Card Reader */
    Product_Application[Product_Application["REGISTER"] = 1] = "REGISTER";
    /**
     * LEGACY_REGISTER - The iPad only version of Register. This product is deprecated. (It was
     * called Register during the time of Square Card Reader)
     */
    Product_Application[Product_Application["LEGACY_REGISTER"] = 2] = "LEGACY_REGISTER";
    /**
     * WALLET - Once known as Pay With Square. Known as Card Case before that.  (was
     * actually Wallet before Card Case during development)
     */
    Product_Application[Product_Application["WALLET"] = 3] = "WALLET";
    Product_Application[Product_Application["TAXIDRIVER"] = 4] = "TAXIDRIVER";
    Product_Application[Product_Application["DASHBOARD"] = 5] = "DASHBOARD";
    Product_Application[Product_Application["CASH"] = 6] = "CASH";
    Product_Application[Product_Application["APPOINTMENTS"] = 7] = "APPOINTMENTS";
})(Product_Application || (Product_Application = {}));
/**
 * The build type (in contrast to prerelease type above. For example, DEVELOPMENT in
 * com.squareup.square.development.)
 */
export var Product_BuildType;
(function (Product_BuildType) {
    Product_BuildType[Product_BuildType["DEVELOPMENT"] = 0] = "DEVELOPMENT";
    Product_BuildType[Product_BuildType["ALPHA"] = 10] = "ALPHA";
    Product_BuildType[Product_BuildType["DOGFOOD"] = 15] = "DOGFOOD";
    Product_BuildType[Product_BuildType["BETA"] = 20] = "BETA";
    Product_BuildType[Product_BuildType["RELEASE"] = 30] = "RELEASE";
})(Product_BuildType || (Product_BuildType = {}));
export var Device_Platform;
(function (Device_Platform) {
    Device_Platform[Device_Platform["IOS"] = 0] = "IOS";
    Device_Platform[Device_Platform["ANDROID"] = 1] = "ANDROID";
    Device_Platform[Device_Platform["JAVASCRIPT"] = 2] = "JAVASCRIPT";
})(Device_Platform || (Device_Platform = {}));
export var Device_Orientation;
(function (Device_Orientation) {
    Device_Orientation[Device_Orientation["PORTRAIT"] = 0] = "PORTRAIT";
    Device_Orientation[Device_Orientation["PORTRAIT_UPSIDE_DOWN"] = 1] = "PORTRAIT_UPSIDE_DOWN";
    Device_Orientation[Device_Orientation["LANDSCAPE_LEFT"] = 2] = "LANDSCAPE_LEFT";
    Device_Orientation[Device_Orientation["LANDSCAPE_RIGHT"] = 3] = "LANDSCAPE_RIGHT";
    Device_Orientation[Device_Orientation["FACE_UP"] = 4] = "FACE_UP";
    Device_Orientation[Device_Orientation["FACE_DOWN"] = 5] = "FACE_DOWN";
    Device_Orientation[Device_Orientation["SQUARE"] = 6] = "SQUARE";
})(Device_Orientation || (Device_Orientation = {}));
export var Connection_Type;
(function (Connection_Type) {
    Connection_Type[Connection_Type["WIFI"] = 0] = "WIFI";
    Connection_Type[Connection_Type["CELL"] = 1] = "CELL";
    Connection_Type[Connection_Type["WIRED"] = 2] = "WIRED";
    Connection_Type[Connection_Type["WIMAX"] = 3] = "WIMAX";
    Connection_Type[Connection_Type["NONE"] = 999] = "NONE";
    Connection_Type[Connection_Type["UNKNOWN"] = 1000] = "UNKNOWN";
})(Connection_Type || (Connection_Type = {}));
export var Reader_Type;
(function (Reader_Type) {
    Reader_Type[Reader_Type["O1"] = 1] = "O1";
    Reader_Type[Reader_Type["S1"] = 2] = "S1";
    Reader_Type[Reader_Type["R4"] = 3] = "R4";
})(Reader_Type || (Reader_Type = {}));
export var Reader_Failure;
(function (Reader_Failure) {
    /** FIRMWARE_HASH_CHECK_FAILED - enum values match client bit masks */
    Reader_Failure[Reader_Failure["FIRMWARE_HASH_CHECK_FAILED"] = 1] = "FIRMWARE_HASH_CHECK_FAILED";
    Reader_Failure[Reader_Failure["KEY_AND_HARDWARE_ID_HASH_CHECK_FAILED"] = 2] = "KEY_AND_HARDWARE_ID_HASH_CHECK_FAILED";
    Reader_Failure[Reader_Failure["TAMPER_DETECT_TRIGGERED"] = 4] = "TAMPER_DETECT_TRIGGERED";
    Reader_Failure[Reader_Failure["COUNTER_FAILED"] = 8] = "COUNTER_FAILED";
})(Reader_Failure || (Reader_Failure = {}));
/**
 * Used to represent appllictaion-defined signficant application
 * states.
 *
 * No current use case submits this as part of the application_state
 * of a message. Rather, clients post a StateTransition message to
 * log a signficant state chnage. But semantically it's part of the
 * application state so is namespaced here.
 */
export var ApplicationState_State;
(function (ApplicationState_State) {
    /** COLD_LAUNCH - Across clients */
    ApplicationState_State[ApplicationState_State["COLD_LAUNCH"] = 1000] = "COLD_LAUNCH";
    ApplicationState_State[ApplicationState_State["BACKGROUND_LAUNCH"] = 1001] = "BACKGROUND_LAUNCH";
    ApplicationState_State[ApplicationState_State["NOT_LOGGED_IN"] = 1002] = "NOT_LOGGED_IN";
    ApplicationState_State[ApplicationState_State["INJECTION_FINISHED"] = 1003] = "INJECTION_FINISHED";
    ApplicationState_State[ApplicationState_State["GOT_LOCATION_FIX"] = 1004] = "GOT_LOCATION_FIX";
    ApplicationState_State[ApplicationState_State["MUST_ENABLE_TABS"] = 1005] = "MUST_ENABLE_TABS";
    /** LAUNCHED_TO_WALLET - Wallet */
    ApplicationState_State[ApplicationState_State["LAUNCHED_TO_WALLET"] = 2000] = "LAUNCHED_TO_WALLET";
    ApplicationState_State[ApplicationState_State["QR_CODE_SHOWN"] = 2001] = "QR_CODE_SHOWN";
    ApplicationState_State[ApplicationState_State["DIRECTORY_CREATED"] = 2002] = "DIRECTORY_CREATED";
    ApplicationState_State[ApplicationState_State["DIRECTORY_LOADED"] = 2003] = "DIRECTORY_LOADED";
    /** REGISTER_AUTHORIZE - Register */
    ApplicationState_State[ApplicationState_State["REGISTER_AUTHORIZE"] = 3000] = "REGISTER_AUTHORIZE";
    /** API_REQUEST - Grandfathered */
    ApplicationState_State[ApplicationState_State["API_REQUEST"] = 10000] = "API_REQUEST";
})(ApplicationState_State || (ApplicationState_State = {}));
function createBaseVersion() {
    return {
        $type: "squareup.common.client.Version",
        major: undefined,
        minor: undefined,
        revision: undefined,
        prereleaseType: undefined,
        prerelease: undefined,
        buildId: undefined,
    };
}
export const Version = {
    $type: "squareup.common.client.Version",
    encode(message, writer = __m0.Writer.create()) {
        if (message.major !== undefined) {
            writer.uint32(8).uint32(message.major);
        }
        if (message.minor !== undefined) {
            writer.uint32(16).uint32(message.minor);
        }
        if (message.revision !== undefined) {
            writer.uint32(24).uint32(message.revision);
        }
        if (message.prereleaseType !== undefined) {
            writer.uint32(32).int32(message.prereleaseType);
        }
        if (message.prerelease !== undefined) {
            writer.uint32(40).uint32(message.prerelease);
        }
        if (message.buildId !== undefined) {
            writer.uint32(50).string(message.buildId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVersion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.major = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.minor = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.revision = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.prereleaseType = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.prerelease = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.buildId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Version.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVersion();
        message.major = object.major ?? undefined;
        message.minor = object.minor ?? undefined;
        message.revision = object.revision ?? undefined;
        message.prereleaseType = object.prereleaseType ?? undefined;
        message.prerelease = object.prerelease ?? undefined;
        message.buildId = object.buildId ?? undefined;
        return message;
    },
};
function createBaseProduct() {
    return {
        $type: "squareup.common.client.Product",
        application: undefined,
        version: undefined,
        buildType: undefined,
        deviceAdvertisingId: undefined,
        deviceTrackingEnabled: undefined,
        deviceInstallationId: undefined,
    };
}
export const Product = {
    $type: "squareup.common.client.Product",
    encode(message, writer = __m0.Writer.create()) {
        if (message.application !== undefined) {
            writer.uint32(8).int32(message.application);
        }
        if (message.version !== undefined) {
            Version.encode(message.version, writer.uint32(18).fork()).ldelim();
        }
        if (message.buildType !== undefined) {
            writer.uint32(24).int32(message.buildType);
        }
        if (message.deviceAdvertisingId !== undefined) {
            writer.uint32(34).string(message.deviceAdvertisingId);
        }
        if (message.deviceTrackingEnabled !== undefined) {
            writer.uint32(42).string(message.deviceTrackingEnabled);
        }
        if (message.deviceInstallationId !== undefined) {
            writer.uint32(50).string(message.deviceInstallationId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProduct();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.application = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.version = Version.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.buildType = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.deviceAdvertisingId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.deviceTrackingEnabled = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.deviceInstallationId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Product.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProduct();
        message.application = object.application ?? undefined;
        message.version = (object.version !== undefined && object.version !== null)
            ? Version.fromPartial(object.version)
            : undefined;
        message.buildType = object.buildType ?? undefined;
        message.deviceAdvertisingId = object.deviceAdvertisingId ?? undefined;
        message.deviceTrackingEnabled = object.deviceTrackingEnabled ?? undefined;
        message.deviceInstallationId = object.deviceInstallationId ?? undefined;
        return message;
    },
};
function createBaseDevice() {
    return {
        $type: "squareup.common.client.Device",
        id: undefined,
        platform: undefined,
        manufacturer: undefined,
        brand: undefined,
        model: undefined,
        osVersion: undefined,
        orientation: undefined,
        languageCode: undefined,
        countryCode: undefined,
    };
}
export const Device = {
    $type: "squareup.common.client.Device",
    encode(message, writer = __m0.Writer.create()) {
        if (message.id !== undefined) {
            writer.uint32(10).string(message.id);
        }
        if (message.platform !== undefined) {
            writer.uint32(16).int32(message.platform);
        }
        if (message.manufacturer !== undefined) {
            writer.uint32(26).string(message.manufacturer);
        }
        if (message.brand !== undefined) {
            writer.uint32(34).string(message.brand);
        }
        if (message.model !== undefined) {
            writer.uint32(42).string(message.model);
        }
        if (message.osVersion !== undefined) {
            Version.encode(message.osVersion, writer.uint32(50).fork()).ldelim();
        }
        if (message.orientation !== undefined) {
            writer.uint32(56).int32(message.orientation);
        }
        if (message.languageCode !== undefined) {
            writer.uint32(64).int32(message.languageCode);
        }
        if (message.countryCode !== undefined) {
            writer.uint32(72).int32(message.countryCode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDevice();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.platform = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.manufacturer = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.brand = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.model = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.osVersion = Version.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.orientation = reader.int32();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.languageCode = reader.int32();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.countryCode = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Device.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDevice();
        message.id = object.id ?? undefined;
        message.platform = object.platform ?? undefined;
        message.manufacturer = object.manufacturer ?? undefined;
        message.brand = object.brand ?? undefined;
        message.model = object.model ?? undefined;
        message.osVersion = (object.osVersion !== undefined && object.osVersion !== null)
            ? Version.fromPartial(object.osVersion)
            : undefined;
        message.orientation = object.orientation ?? undefined;
        message.languageCode = object.languageCode ?? undefined;
        message.countryCode = object.countryCode ?? undefined;
        return message;
    },
};
function createBaseConnection() {
    return { $type: "squareup.common.client.Connection", type: undefined, carrier: undefined };
}
export const Connection = {
    $type: "squareup.common.client.Connection",
    encode(message, writer = __m0.Writer.create()) {
        if (message.type !== undefined) {
            writer.uint32(8).int32(message.type);
        }
        if (message.carrier !== undefined) {
            writer.uint32(18).string(message.carrier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConnection();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.carrier = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Connection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConnection();
        message.type = object.type ?? undefined;
        message.carrier = object.carrier ?? undefined;
        return message;
    },
};
function createBaseReader() {
    return {
        $type: "squareup.common.client.Reader",
        type: undefined,
        id: undefined,
        counter: undefined,
        errorCode: undefined,
        nonSuccessMessage: undefined,
        path: undefined,
        failure: [],
    };
}
export const Reader = {
    $type: "squareup.common.client.Reader",
    encode(message, writer = __m0.Writer.create()) {
        if (message.type !== undefined) {
            writer.uint32(8).int32(message.type);
        }
        if (message.id !== undefined) {
            writer.uint32(18).string(message.id);
        }
        if (message.counter !== undefined) {
            writer.uint32(24).uint32(message.counter);
        }
        if (message.errorCode !== undefined) {
            writer.uint32(34).string(message.errorCode);
        }
        if (message.nonSuccessMessage !== undefined) {
            writer.uint32(42).string(message.nonSuccessMessage);
        }
        if (message.path !== undefined) {
            writer.uint32(50).string(message.path);
        }
        writer.uint32(58).fork();
        for (const v of message.failure) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.counter = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.errorCode = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.nonSuccessMessage = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.path = reader.string();
                    continue;
                case 7:
                    if (tag === 56) {
                        message.failure.push(reader.int32());
                        continue;
                    }
                    if (tag === 58) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.failure.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Reader.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReader();
        message.type = object.type ?? undefined;
        message.id = object.id ?? undefined;
        message.counter = object.counter ?? undefined;
        message.errorCode = object.errorCode ?? undefined;
        message.nonSuccessMessage = object.nonSuccessMessage ?? undefined;
        message.path = object.path ?? undefined;
        message.failure = object.failure?.map((e) => e) || [];
        return message;
    },
};
function createBaseScope() {
    return { $type: "squareup.common.client.Scope", uuid: undefined, start: undefined };
}
export const Scope = {
    $type: "squareup.common.client.Scope",
    encode(message, writer = __m0.Writer.create()) {
        if (message.uuid !== undefined) {
            writer.uint32(10).string(message.uuid);
        }
        if (message.start !== undefined) {
            DateTime.encode(message.start, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScope();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.uuid = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.start = DateTime.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Scope.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScope();
        message.uuid = object.uuid ?? undefined;
        message.start = (object.start !== undefined && object.start !== null)
            ? DateTime.fromPartial(object.start)
            : undefined;
        return message;
    },
};
function createBaseApplicationState() {
    return {
        $type: "squareup.common.client.ApplicationState",
        state: undefined,
        launchScope: undefined,
        foregroundScope: undefined,
        paymentAttemptScope: undefined,
        screen: undefined,
    };
}
export const ApplicationState = {
    $type: "squareup.common.client.ApplicationState",
    encode(message, writer = __m0.Writer.create()) {
        if (message.state !== undefined) {
            writer.uint32(8).int32(message.state);
        }
        if (message.launchScope !== undefined) {
            Scope.encode(message.launchScope, writer.uint32(82).fork()).ldelim();
        }
        if (message.foregroundScope !== undefined) {
            Scope.encode(message.foregroundScope, writer.uint32(90).fork()).ldelim();
        }
        if (message.paymentAttemptScope !== undefined) {
            Scope.encode(message.paymentAttemptScope, writer.uint32(98).fork()).ldelim();
        }
        if (message.screen !== undefined) {
            writer.uint32(8002).string(message.screen);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApplicationState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.state = reader.int32();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.launchScope = Scope.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.foregroundScope = Scope.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.paymentAttemptScope = Scope.decode(reader, reader.uint32());
                    continue;
                case 1000:
                    if (tag !== 8002) {
                        break;
                    }
                    message.screen = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ApplicationState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApplicationState();
        message.state = object.state ?? undefined;
        message.launchScope = (object.launchScope !== undefined && object.launchScope !== null)
            ? Scope.fromPartial(object.launchScope)
            : undefined;
        message.foregroundScope = (object.foregroundScope !== undefined && object.foregroundScope !== null)
            ? Scope.fromPartial(object.foregroundScope)
            : undefined;
        message.paymentAttemptScope = (object.paymentAttemptScope !== undefined && object.paymentAttemptScope !== null)
            ? Scope.fromPartial(object.paymentAttemptScope)
            : undefined;
        message.screen = object.screen ?? undefined;
        return message;
    },
};
